<template>
  <div class="contact-page">
    <Header />
    
    <div class="page-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <h1>联系我们</h1>
        <p>期待与您建立长期合作关系</p>
        <div class="scroll-indicator">
          <span>向下滚动了解更多</span>
          <i class="bi bi-chevron-down"></i>
        </div>
      </div>
    </div>
    
    <section class="contact-info">
      <div class="container">
        <div class="section-title">
          <span class="subtitle">沟通合作</span>
          <h2>联系方式</h2>
          <div class="divider"></div>
          <p>随时为您提供专业的猎头咨询服务</p>
        </div>
        
        <div class="contact-grid">
          <div class="contact-card">
            <div class="icon">
              <i class="bi bi-geo-alt"></i>
            </div>
            <h3>公司地址</h3>
            <p>上海市普陀区中山北路<br />华源世界大厦<br />邮编：200063</p>
          </div>
          
          <div class="contact-card">
            <div class="icon">
              <i class="bi bi-telephone"></i>
            </div>
            <h3>咨询热线</h3>
            <p>供应链、物流：<br /><a href="tel:021-63806309">021-63806309</a></p>
            <p>新能源、电力：<br /><a href="tel:021-63800880">021-63800880</a></p>
            <p>互联网、电子商务：<br /><a href="tel:021-63800212">021-63800212</a></p>
          </div>
          
          <div class="contact-card">
            <div class="icon">
              <i class="bi bi-envelope"></i>
            </div>
            <h3>电子邮箱</h3>
            <p>业务咨询：<br /><a href="mailto:admin@jc-talent.com">admin@jc-talent.com</a></p>
            <p>工作机会：<br /><a href="mailto:rober.liu@jc-talent.com">rober.liu@jc-talent.com</a></p>
          </div>
          
          <div class="contact-card">
            <div class="icon">
              <i class="bi bi-wechat"></i>
            </div>
            <h3>微信公众号</h3>
            <div class="qrcode">
              <img src="@/assets/wechat_code.jpg" alt="俊采猎头微信公众号" />
            </div>
            <p>扫描关注我们的公众号<br />获取最新资讯</p>
          </div>
        </div>
      </div>
    </section>
    
    <section class="company-location">
      <div class="container">
        <div class="section-title">
          <span class="subtitle">来访指引</span>
          <h2>公司位置</h2>
          <div class="divider"></div>
        </div>
        
        <div class="location-container">
          <div class="map-wrapper">
            <div class="baidu-map" id="baiduMap"></div>
          </div>
          
          <div class="location-info">
            <div class="info-card">
              <h3>来访指南</h3>
              <div class="info-item">
                <i class="bi bi-pin-map"></i>
                <div>
                  <strong>详细地址：</strong>
                  <p>上海市普陀区中山北路华源世界大厦</p>
                </div>
              </div>
              
              <div class="info-item">
                <i class="bi bi-train-front"></i>
                <div>
                  <strong>地铁路线：</strong>
                  <p>地铁3号线、4号线、7号线至镇坪路站下车，1号出口步行约300米</p>
                </div>
              </div>
              
              <div class="info-item">
                <i class="bi bi-bus-front"></i>
                <div>
                  <strong>公交路线：</strong>
                  <p>公交41路、947路至中山北路镇坪路站下车</p>
                </div>
              </div>
              
              <div class="info-item">
                <i class="bi bi-clock"></i>
                <div>
                  <strong>办公时间：</strong>
                  <p>周一至周五：9:00 - 18:00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <section class="contact-form">
      <div class="container">
        <div class="section-title">
          <span class="subtitle">业务咨询</span>
          <h2>给我们留言</h2>
          <div class="divider"></div>
          <p>如果您有任何疑问或需求，请填写下面的表单，我们会尽快与您联系</p>
        </div>
        
        <form class="form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label for="name">姓名 <span>*</span></label>
              <input type="text" id="name" v-model="form.name" required>
            </div>
            
            <div class="form-group">
              <label for="company">公司名称 <span>*</span></label>
              <input type="text" id="company" v-model="form.company" required>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label for="position">职位</label>
              <input type="text" id="position" v-model="form.position">
            </div>
            
            <div class="form-group">
              <label for="service">服务需求</label>
              <select id="service" v-model="form.service">
                <option value="">请选择您需要的服务</option>
                <option value="物流供应链">物流供应链猎头服务</option>
                <option value="互联网电子商务">互联网电子商务猎头服务</option>
                <option value="新能源电力">新能源电力猎头服务</option>
                <option value="其他">其他</option>
              </select>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label for="email">电子邮箱 <span>*</span></label>
              <input type="email" id="email" v-model="form.email" required>
            </div>
            
            <div class="form-group">
              <label for="phone">电话 <span>*</span></label>
              <input type="tel" id="phone" v-model="form.phone" required>
            </div>
          </div>
          
          <div class="form-group full-width">
            <label for="message">留言内容 <span>*</span></label>
            <textarea id="message" v-model="form.message" rows="5" required></textarea>
          </div>
          
          <div class="form-submit">
            <button type="submit" class="submit-btn">
              <span>提交</span>
              <i class="bi bi-arrow-right"></i>
            </button>
          </div>
        </form>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'ContactPage',
  components: {
    Header,
    Footer
  },
  setup() {
    const form = ref({
      name: '',
      company: '',
      position: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
    
    const submitForm = () => {
      // 表单提交逻辑，实际项目中可能需要连接到后端API
      console.log('表单提交成功：', form.value);
      alert('感谢您的留言，我们会尽快与您联系！');
      // 重置表单
      form.value = {
        name: '',
        company: '',
        position: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      };
    };
    
    onMounted(() => {
      // 在组件挂载后加载百度地图
      const loadBaiduMap = () => {
        if (typeof window.BMap !== 'undefined') {
          initMap();
        } else {
          // 动态加载百度地图API
          const script = document.createElement('script');
          script.src = 'https://api.map.baidu.com/api?v=3.0&ak=E682390c2ad892cef4717d8efbd96e1e&callback=initBaiduMap';
          script.async = true;
          document.body.appendChild(script);
          
          // 全局回调函数
          window.initBaiduMap = initMap;
        }
      };
      
      const initMap = () => {
        const map = new window.BMap.Map('baiduMap');
        const point = new window.BMap.Point(121.433303, 31.235718); // 上海普陀区中山北路坐标（示例）
        map.centerAndZoom(point, 16);
        map.enableScrollWheelZoom(); // 启用滚轮缩放
        
        // 添加标记
        const marker = new window.BMap.Marker(point);
        map.addOverlay(marker);
        
        // 添加信息窗口
        const infoWindow = new window.BMap.InfoWindow('上海俊采猎头 - 华源世界大厦', {
          title: '我们的办公地点',
          width: 220
        });
        marker.addEventListener('click', function() {
          map.openInfoWindow(infoWindow, point);
        });
      };
      
      // 加载百度地图
      loadBaiduMap();
    });
    
    return {
      form,
      submitForm
    };
  }
}
</script>

<style scoped>
.contact-page {
  overflow-x: hidden;
}

.page-banner {
  height: 500px;
  background-image: url('@/assets/wallpaper6.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.banner-content {
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner-content h1 {
  font-size: 42px;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  font-weight: 700;
}

.banner-content p {
  font-size: 20px;
  margin-bottom: 30px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.scroll-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  animation: bounce 2s infinite;
  text-align: center;
}

.scroll-indicator span {
  font-size: 14px;
  margin-bottom: 5px;
  opacity: 0.8;
}

.scroll-indicator i {
  font-size: 20px;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title .subtitle {
  display: inline-block;
  color: #009688;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  position: relative;
}

.section-title .subtitle:before, .section-title .subtitle:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 20px;
  height: 1px;
  background-color: #009688;
}

.section-title .subtitle:before {
  left: -30px;
}

.section-title .subtitle:after {
  right: -30px;
}

.section-title h2 {
  font-size: 32px;
  margin-bottom: 15px;
  color: #1a2b2b;
  font-weight: 700;
}

.section-title p {
  color: #6a7676;
  max-width: 700px;
  margin: 0 auto;
}

.divider {
  width: 60px;
  height: 3px;
  background-color: #009688;
  margin: 0 auto 20px;
}

.contact-info {
  padding: 100px 0;
  background-color: #fff;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.contact-card {
  background-color: #fff;
  padding: 40px 20px;
  border-radius: 16px;
  text-align: center;
  border: 1px solid #eef1f0;
  box-shadow: 0 4px 18px rgba(20, 40, 40, 0.05);
  transition: transform .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              box-shadow .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              border-color .4s ease;
}

.contact-card:hover {
  transform: translateY(-10px);
  border-color: transparent;
  box-shadow: 0 22px 44px rgba(0, 121, 107, 0.18);
}

.contact-card .icon {
  width: 76px;
  height: 76px;
  background: linear-gradient(135deg, #009688 0%, #4CAF50 100%);
  color: #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  margin: 0 auto 20px;
  box-shadow: 0 10px 22px rgba(0, 150, 136, 0.28);
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.contact-card:hover .icon {
  transform: translateY(-4px) rotate(-6deg);
}

.contact-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #1a2b2b;
}

.contact-card p {
  color: #6a7676;
  line-height: 1.6;
  margin-bottom: 10px;
}

.contact-card a {
  color: #009688;
  text-decoration: none;
  transition: color 0.3s;
}

.contact-card a:hover {
  color: #007065;
}

.qrcode {
  width: 150px;
  height: 150px;
  margin: 0 auto 15px;
  border: 4px solid #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
}

.qrcode img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.company-location {
  padding: 100px 0;
  background-color: #f5f5f5;
}

.location-container {
  display: flex;
  gap: 30px;
  align-items: stretch;
}

.map-wrapper {
  flex: 2;
  height: 500px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.baidu-map {
  width: 100%;
  height: 100%;
}

.location-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.info-card {
  background-color: #fff;
  border-radius: 16px;
  padding: 30px;
  border: 1px solid #eef1f0;
  box-shadow: 0 4px 18px rgba(20, 40, 40, 0.05);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              box-shadow .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              border-color .4s ease;
}

.info-card:hover {
  transform: translateY(-10px);
  border-color: transparent;
  box-shadow: 0 22px 44px rgba(0, 121, 107, 0.18);
}

.info-card h3 {
  font-size: 24px;
  color: #1a2b2b;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.info-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item i {
  font-size: 22px;
  color: #009688;
  margin-right: 15px;
  margin-top: 3px;
}

.info-item strong {
  display: block;
  margin-bottom: 5px;
  color: #1a2b2b;
}

.info-item p {
  color: #6a7676;
  line-height: 1.6;
  margin: 0;
}

.contact-form {
  padding: 100px 0;
  background-color: #fff;
}

.form {
  max-width: 800px;
  margin: 0 auto;
  background-color: #fff;
  padding: 40px;
  border-radius: 16px;
  border: 1px solid #eef1f0;
  box-shadow: 0 4px 18px rgba(20, 40, 40, 0.05);
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-group {
  flex: 1;
  margin-bottom: 25px;
}

.form-group.full-width {
  width: 100%;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #1a2b2b;
  font-weight: 500;
}

.form-group label span {
  color: #ff4d4f;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #e2e6e5;
  border-radius: 10px;
  font-size: 16px;
  color: #1a2b2b;
  background-color: #fff;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #009688;
  box-shadow: 0 0 0 4px rgba(0, 150, 136, 0.15);
  outline: none;
}

.form-submit {
  text-align: center;
  margin-top: 20px;
}

.submit-btn {
  background: linear-gradient(135deg, #009688, #00796b);
  color: #fff;
  border: none;
  padding: 13px 34px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(0, 150, 136, 0.22);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.submit-btn span {
  margin-right: 10px;
}

.submit-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 28px rgba(0, 150, 136, 0.35);
}

/* 响应式样式 */
@media (max-width: 1200px) {
  .contact-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .location-container {
    flex-direction: column;
  }
  
  .map-wrapper {
    height: 400px;
  }
  
  .form-row {
    flex-direction: column;
    gap: 0;
  }
}

@media (max-width: 768px) {
  .page-banner {
    height: 400px;
  }
  
  .banner-content h1 {
    font-size: 32px;
  }
  
  .banner-content p {
    font-size: 18px;
  }
  
  .contact-info, .contact-form, .company-location {
    padding: 70px 0;
  }
  
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .contact-card {
    padding: 30px 15px;
  }
  
  .form {
    padding: 30px 20px;
  }

  .form-group input,
  .form-group select {
    min-height: 44px;
  }

  .form-group textarea {
    min-height: 88px;
  }

  .info-card {
    padding: 25px;
  }
}

@media (max-width: 576px) {
  .page-banner {
    height: 300px;
    margin-top: 60px;
  }
  
  .banner-content h1 {
    font-size: 28px;
  }
  
  .banner-content p {
    font-size: 16px;
  }
  
  .section-title h2 {
    font-size: 26px;
  }
  
  .contact-info, .contact-form, .company-location {
    padding: 50px 0;
  }
  
  .map-wrapper {
    height: 300px;
  }
  
  .form-submit {
    margin-top: 10px;
  }
  
  .submit-btn {
    width: 100%;
    padding: 12px 20px;
  }
}
</style> 